import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

window.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector<HTMLElement>('#gallery');

    if (!grid) {
        return;
    }

    const initLightbox = (elem: HTMLElement) => {
        const lightbox = new PhotoSwipeLightbox({
            bgOpacity: 0.6,
            gallery: elem,
            children: 'a',
            pswpModule: () => import('photoswipe'),
            wheelToZoom: true,
            closeOnVerticalDrag: true,
            paddingFn: (viewportSize) => {
                return {
                    top: viewportSize.y * 0.1,
                    right: viewportSize.x * 0.1,
                    bottom: viewportSize.y * 0.1,
                    left: viewportSize.x * 0.1
                };
            },
        });

        lightbox.on('uiRegister', function () {
            lightbox.pswp.ui.registerElement({
                name: 'bulletsIndicator',
                className: 'pswp__bullets-indicator',
                appendTo: 'wrapper',
                onInit: (el, pswp) => {
                    const bullets = [];
                    let bullet: HTMLDivElement;
                    let prevIndex = -1;

                    for (let i = 0; i < pswp.getNumItems(); i++) {
                        bullet = document.createElement('div');
                        bullet.className = 'pswp__bullet';
                        bullet.onclick = (e) => {
                            pswp.goTo(bullets.indexOf(e.target));
                        };

                        const thumbnailURL = pswp.options.dataSource ? pswp.options.dataSource.items[i].href : '';
                        bullet.style.backgroundImage = `url(${thumbnailURL})`;
                        bullet.style.backgroundSize = 'cover';

                        el.appendChild(bullet);
                        bullets.push(bullet);
                    }

                    pswp.on('change', () => {
                        if (prevIndex >= 0) {
                            bullets[prevIndex].classList.remove('pswp__bullet--active');
                        }
                        bullets[pswp.currIndex].classList.add('pswp__bullet--active');
                        prevIndex = pswp.currIndex;
                    });
                }
            });
        });

        lightbox.init();
    }

    initLightbox(grid);
});